module.exports = __webpack_public_path__ + "media/10434_1758004197.55584f31.mp4";